import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/variables.css'

// Firebase veri kontrol araçları (development için)
if (import.meta.env.DEV) {
  import('./utils/checkFirebaseData');
  import('./utils/testSellerApproval');
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
